<template>
<router-link :to="route" class="block">
  <article class="offer-item">
    <figure class="offer-image">
      <responsive-image v-if="hasOfferCover"
                        :media="banner.image"
                        :sizes="['large', 'medium']"
      />
    </figure>
    <div class="offer-content">
      <div class="text-container">
        <h3 v-if="banner.title" class="offer-title">{{ banner.title }}</h3>
        <p v-if="banner.description">{{ banner.description }}</p>
      </div>
    </div>
  </article>
</router-link>
</template>

<script>
import ResponsiveImage from '@/components/images/ResponsiveImage'

export default {
  props: {
    offer: {
      required: true,
      type: Object,
    },
  },

  components: {
    ResponsiveImage,
  },

  computed: {
    hasOfferCover() {
      return !!this.banner && !!this.banner.image && !!this.banner.image.images && Object.keys(this.banner.image.images).length > 0
    },

    banner() {
      return this.offer.banners.desktop
    },

    article() {
      return this.offer.article
    },

    route() {
      if (!this.article || !this.article.title) {
        return '#'
      }

      return {
        name: 'offer-page',
        params: {
          shortId: this.offer.short_id,
          slug: this.offer.slug,
        },
      }
    },
  },
}
</script>
